import { CALL_API } from 'redux-api-middleware'
import { get, post, put, destroy } from 'utils/network'

export const searchPaymentScheme = (q) => {
  const query = {
    q,
    by: 'code',
  }
  const request = get('/payment-schemes/search', query)
  request.types = ['PS_Q_REQ', 'PS_Q_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const searchFee = (q) => {
  const query = {
    q,
    by: 'code',
  }
  const request = get('/fees/search', query)
  request.types = ['FEE_Q_REQ', 'FEE_Q_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const fetchPaymentScheme = (paymentschemeID) => (dispatch, getState) => {
  if (getState().paymentscheme.getIn(['item', 'id']) === paymentschemeID) {
    return Promise.resolve()
  }
  const request = get(`/payment-schemes/${paymentschemeID}`)
  request.types = ['PS_REQ', 'PS_GET_SUCC', 'NOTIF_FAIL']
  return dispatch({ [CALL_API]: request })
}

export const fetchPaymentSchemeFees = (paymentschemeID) => (dispatch, getState) => {
  if (getState().paymentscheme.getIn(['items', paymentschemeID])) {
    return Promise.resolve()
  }

  const request = get(`/payment-schemes/${paymentschemeID}/fees`)
  request.types = [
    'PS_REQ',
    {
      type: 'PSF_GET_SUCC',
      meta: { paymentschemeID },
    },
    'NOTIF_FAIL',
  ]
  return dispatch({ [CALL_API]: request })
}

// POST /payment-schemes
export const savePaymentScheme = (payload) => {
  let request = null
  if (payload.get('id')) {
    // update
    request = put('/payment-schemes/' + payload.get('id'), payload)
  } else {
    // create
    request = post('/payment-schemes', payload)
  }

  request.types = ['PS_REQ', 'PS_SAVE_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

// POST /payment-schemes/:paymentschemeID/fees
export const savePaymentSchemeFee = (paymentschemeID, payload) => {
  let request = null
  if (payload.get('id')) {
    // update
    request = put(`/payment-schemes/${paymentschemeID}/fees/${payload.get('id')}`, payload)
  } else {
    // create
    request = post(`/payment-schemes/${paymentschemeID}/fees`, payload)
  }
  request.types = [
    'PSF_REQ',
    {
      type: 'PSF_SAVE_SUCC',
      meta: { paymentschemeID },
    },
    'NOTIF_FAIL',
  ]

  return { [CALL_API]: request }
}

export const deletePaymentScheme = (paymentschemeID) => {
  const request = destroy(`/payment-schemes/${paymentschemeID}`)
  request.types = ['PS_REQ', 'PS_DEL_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const deletePaymentSchemeFee = (paymentschemeID, psfID) => {
  const request = destroy(`/payment-schemes/${paymentschemeID}/fees/${psfID}`)
  request.types = [
    'PSF_REQ',
    {
      type: 'PSF_DEL_SUCC',
      meta: { paymentschemeID },
    },
    'NOTIF_FAIL',
  ]
  return { [CALL_API]: request }
}



// WEBPACK FOOTER //
// ./src/containers/Manage/PaymentSchemes/actions.js